package team.platforma.multiplatform_material_extension.ui.buttons.utils

enum class TextGravity {
    Start, End, Center
}